$(function() {
    if (checkBrowsers().indexOf("ie8") != -1) {
        alert((LANGUAGES[CURR_LANGUAGE]['Message_IE8UnsupportWarning'] || 'Message_IE8UnsupportWarning'));
    }
   
    if("Linux" == $clientInfo.os &&  "Firefox" == $clientInfo.browser){// #12200 The EonOne background is incomplete in Linux
        document.body.style.backgroundAttachment = 'scroll';
    }
    //var myuri = new URI(document.URL);
    var myuri = new URI(location.href);
    // var startIndex = myuri.authority.lastIndexOf(":");
    // var IPaddr = myuri.authority.substring(0, startIndex);
    //$('#currIPSpan').attr("value", IPaddr);
    document.getElementById('PWDhint').setAttribute('title', FMT('ForgotPWDHint'));
    switch (myuri.fragment) {
        case 'loginerr':
            $('#myAlert').show();
            $('#myPWDhint').show();
            break;
        case 'ClusterIpInUse':
        case 'KickedOut':
            $('#ClusterIpInUse').show();
            document.getElementById('ClusterIpInUse_msg').innerHTML = FMT('logoutByClusterManager');
            break;
        case 'AccountDisabled':
            $('#AccountDisabled').show();
            document.getElementById('AccountDisabled_msg').innerHTML = FMT('AccountDisabled');
            break;
        case 'LoginFailedInHAMode':
            $('#LoginFailedInHAMode').show();
            document.getElementById('LoginFailedInHAMode_msg').innerHTML = FMT('LoginFailedInHAMode');
            break;
        case 'FailedLoginMemberEonOne':
            document.getElementById('FailedLoginMemberEonOne').insertAdjacentHTML('beforeend', FMT('FailedLoginMemberEonOne'));
            $('#FailedLoginMemberEonOne').show();
            break;
        case 'ModelNotSupportMnEOSS':
            $('#ModelNotSupportMnEOSS').show();
            if (getCookie('E_setUserName') === 'Madmin') {
                document.getElementById('ModelNotSupportMnEOSS_msg').innerHTML = FMT('ModelNotSupportMnEOSS').replaceAll("{0}", "MnE project server");
            } else if (getCookie('E_setUserName') === 'Oadmin') {
                document.getElementById('ModelNotSupportMnEOSS_msg').innerHTML = FMT('ModelNotSupportMnEOSS').replaceAll("{0}", "Office share service");
            } else {
                document.getElementById('ModelNotSupportMnEOSS_msg').innerHTML = '';
            }
            break;
        case 'mfalogin':
            displayMFA(false);
            break;
        case 'mfalogin#verifyerr':
            displayMFA(true);
            break;
    }
    document.onkeydown = function(event) {
        if (event.which == 13) { //detect keyboard "enter" button event
            if($('#loginMFA').hasClass('in')) {
                if($("#MFALogin").attr('disabled') === undefined)
                    validateMFA();
            }
            else 
                validateLogin();
        }
    };
    
    setCookie('E_JSESSIONID', '', 365); //remove cookie when login or logout
    checkCookie();
    checkInput();

    window.addEventListener('input', function() {
        checkInput();
    });
});
function displayMFA(isVerifyerr) {
    var theUrl = '/cmd/EonOne/config/getVendorInfo';
    $.ajax({
        url: theUrl,
        type: 'post',
        dataType: 'text',
        async: false,
        success: function (data) {
            let isCentralMode = true;
            if(data.indexOf("true") > -1){   // Embedded mode 
                isCentralMode = false;
            } else{   // Central mode
                $('#PWDhint').hide();
            }
            $('#loginMFA').modal({show: true, backdrop: 'static', keyboard: true, closeOnEscape: false});
            $('.modal-dialog').draggable({
                handle: ".modal-header"
            });

            if(isVerifyerr){
                $("#verifyCodeResult").text(FMT('VerificationFailed'));
            } else {
                setCookie('isUseBackupCode', 'false', 365);
                setCookie('isSendEmail', 'false', 365);
                setCookie('isUsedEmailOTP', 'false', 365);
                $("#verifyCodeResult").text('');
            }
            $("input[name=j_verifyCode]").val('');
            
            if(isCentralMode){
                $("#sendEmailLink").css("display", "none");
            } else {
                $("#sendEmailLink").removeClass("disableLink");
            }

            if(isVerifyerr && getCookie('isUseBackupCode') === 'true'){
                changeToBackupCode(true);
            }
            if(isVerifyerr  && getCookie("isSendEmail") === 'true') {
                $("#sendEmailLink").addClass("disableLink");
            }
            $("#verifyCode").focus();
        }
    });
}



function closeMFADialog() {
    $("#sendEmailLink").removeClass("disableLink");
    $("[data-toggle=tooltip").removeClass("invalidInput");
    $("[data-toggle=tooltip").tooltip('disable');
    $('#loginMFA').modal('hide');
}

function validateMFA() {
    setCookie('isUseBackupCode', ($("#codeTitle").text() === FMT('EnterBackupCode')).toString() , 365);
    setCookie('isSendEmail', $("#sendEmailLink").hasClass("disableLink").toString() , 365);
    setCookie('isUsedEmailOTP', ($("#verifyCode").val().length ===7).toString(), 365);
    $("#loginToken").val(getCookie("token"));
    $('#mfaLoginForm').submit();
}

function changeToBackupCode(isShowErrMsg){
    // clean verify code
    $("#verifyCode").val('');
    $("#verifyCode").removeClass("invalidInput");
    $("#verifyCode").tooltip('disable');

    if(!isShowErrMsg)
        $("#verifyCodeResult").text('');
    $("#codeTitle").text(FMT("EnterBackupCode"));
    $("#hintBox").css("display", "block");
    $("#mfaLoginForm a").css("display", "none");
    $("#verifyCode").focus();
}

function checkInput () {
    if (!document.querySelector('#username').value || !document.querySelector('#pass').value) {
        document.querySelector('#login').disabled = true;
    } else {
        document.querySelector('#login').disabled = false;
    }
}

function validateLogin() {
    setCookie('E_setUserName', $('input[name=j_username]').val(), 365);
    getValidateLoginResult(data => {
        if (data === '') {
            applylogin();
        } else {
            switch (data) {
                case 'ClusterIpInUse':
                case 'KickedOut':
                case 'AccountDisabled':
                case 'ModelNotSupportMnEOSS':
                case 'LoginFailedInHAMode':
                    location.replace(`${location.protocol}//${location.host}/login-gs.html#${data}`);
                    location.reload();
                    break;
                default:
                    console.warn('https client not ready');
                    applylogin();
            }
        }
    });
}

function applylogin() {

    if ($('#checkrempass').prop('checked') == true) {
        setCookie('E_isRememberPswd', 'true', 365);
        setCookie('E_password', $('input[name=j_password]').val(), 365);
        setCookie('E_userName', $('input[name=j_username]').val(), 365);
    } else {
        setCookie('E_isRememberPswd', 'false', 365);
        setCookie('E_password', '', 365);
        setCookie('E_userName', '', 365);
    }
    setCookie('E_isloginPage', true, 365);
    $('#loginform').attr('action', getURLStr() + '/j_security_check');
    $('#loginform').submit();
}

function showMsgDialog(type, msg){
    $('#msgModal').modal({show: true, backdrop: 'static', keyboard: true, closeOnEscape: false});
    if(type === 'error'){
        $("#msgTitle").text(FMT("Error"));
        $('#msgImg').attr('src','Public/gs/images/Message_Icon_Error.png');
    }
    else{
        $("#msgTitle").text(FMT("Information"));
        $('#msgImg').attr('src','Public/images/IconAssets/Status Icons/status_icon_Infor.svg');
    }

    $('#msgContent').text(msg);
}
// function toggleRemPW() {
//     if (!$('#checkrempass').prop('checked')) {
//         $('#loginform').attr('autocomplete', 'off');
//     } else {
//         $('#loginform').attr('autocomplete', null);
//     }
// }

function getURLStr() {
    var myuri = new URI(location.href);
    var startIndex = myuri.authority.lastIndexOf(":");
    var IPaddr = myuri.authority.substring(0, startIndex);
    //var IPaddr = $('#currIPSpan').attr("value");
    if (!$('#checkusessl').prop('checked')) {
        //return "http://" + IPaddr + ":8818";
        return "http://" + IPaddr + ":8816";
    } else
        return "https://" + IPaddr + ":8817";
}

function checkCookie() {
    var isRememberPswd = getCookie('E_isRememberPswd');
    if (isRememberPswd == 'true') {
        $('#checkrempass').prop('checked', true);
        var password = getCookie('E_password');
        $('input[name=j_password]').val(password);
        var userName = getCookie('E_userName');
        $('input[name=j_username]').val(userName);
    }
    if (isSecure())
        $('#checkusessl').prop('checked', true);
}

function isSecure() {
    return location.protocol == 'https:';
}
/* for original list
    function getCurLang(){
        var host = location.host;
        var theUrl = '/cmd/EonOne/config/getCurLang';
        $.ajax({
            url: theUrl,
            type: 'post',
            dataType: 'text',
            async: false,
            success: function (data) {
                if(data == "en"){
                    $('#currentLang').html("English");
                }else if(data == "de"){
                    $('#currentLang').html("Deutsch");
                }else if(data == "fr"){
                    $('#currentLang').html("Français");
                }else if(data == "ru"){
                    $('#currentLang').html("Русский");
                }else if(data == "jp"){
                    $('#currentLang').html("日本語");
                }else if(data == "cn"){
                    $('#currentLang').html("简体中文");
                }else if(data == "tw"){
                    $('#currentLang').html("繁體中文");
                }
            }
        });
    }*/
// function getCurLangC(callback){
//     var theUrl = '/cmd/EonOne/config/getCurLang';
//     $.ajax({
//         url: theUrl,
//         type: 'post',
//         dataType: 'text',
//         async: false,
//         success: function (data) {
//             callback(data);
//         }
//     });
// }
function getVendorInfo(){
    var theUrl = '/cmd/EonOne/config/getVendorInfo';
    $.ajax({
        url: theUrl,
        type: 'post',
        dataType: 'text',
        async: false,
        success: function (data) {
            //document.getElementById("vendorInfo").src = "Public/gs/images/login_logo.png" ;
            if(data.indexOf("true") > -1){   // Embedded mode

            } else{   // Central mode
                $('#PWDhint').hide();
            } 
        }
    });
} 
function getValidateLoginResult(callback) {
    var theUrl = '/cmd/EonOne/config/getLoginValidateMsg';
    let data = {
        account: document.querySelector('#username').value
    };
    $.ajax({
        url: theUrl,
        type: 'get',
        dataType: 'text',
        data,
        async: false,
        success: function (data) {
            callback(data);
        }
    });
}

$( document ).ready(function() {
    // for original list
    /*
    $("#en").click(function(){
        changeConfigLang2('en');
    });
    $("#de").click(function(){
        changeConfigLang2('de');
    });
    $("#fr").click(function(){
        changeConfigLang2('fr');
    });
    $("#ru").click(function(){
        changeConfigLang2('ru');
    });
    $("#jp").click(function(){
        changeConfigLang2('jp');
    });
    $("#cn").click(function(){
        changeConfigLang2('cn');
    });
    $("#tw").click(function(){
        changeConfigLang2('tw');
    });
    getCurLang(); //temporary closeing
    */
    getVendorInfo();
    let verifyCodeLength = 6;
   
    $("#verifyCode").attr('title', '');
    $("#verifyCode").tooltip();
    $("#verifyCode").tooltip('disable');
    if($("#verifyCode").val() === '')
        $("#MFALogin").attr('disabled', 'disabled');

    let myuri = new URI(location.href);
    let isLoginVerifyFail = myuri.fragment === 'mfalogin#verifyerr';

    if(isLoginVerifyFail && getCookie('isUsedEmailOTP') === 'true'){
        verifyCodeLength = 7;
    } else if(isLoginVerifyFail && getCookie('isUsedEmailOTP') === 'false'){
        verifyCodeLength = 6;
    }
    $("#verifyCode").on("input",()=> {

        let isBackupCode = $("#codeTitle").text() === FMT("EnterBackupCode");
        let re = isBackupCode? /^[0-9A-Za-z]+$/ :/^[0-9]+$/;

        let self =  $("#verifyCode");
        const result = self.val().match(re);
        if(result === null && self.val() !== '') {
            self.tooltip('hide')
                .attr('data-original-title', FMT('Message_EnterInvalidCharacter'))
                .tooltip('show');
            self.tooltip('enable');
            self.addClass("invalidInput");
            $("#MFALogin").attr('disabled', 'disabled');
        }
        else {
            self.removeClass("invalidInput");
            self.tooltip('disable');
            if(isBackupCode && (self.val().length === 8))
                $("#MFALogin").removeAttr("disabled");
            else if(!isBackupCode && (self.val().length === verifyCodeLength))
                $("#MFALogin").removeAttr("disabled");
            else
                $("#MFALogin").attr('disabled', 'disabled');
        }
    });


    $("#sendEmailLink").click(()=>{
        let url = 'cmd/api/MFAemail/sendEmail';
        let obj = {
            'token': getCookie("token"),
        };
        
        $("#blockUIProgress").css("display", "");
        $("#sendEmailLink").addClass("disableLink");
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'text',
            data: JSON.stringify(obj),
            contentType: 'application/json;charset=UTF-8',
            async: true,
            success: function (data) {
                let result = JSON.parse(data);
                $("#blockUIProgress").css("display", "none");
                showMsgDialog(result.status, FMT(result.key));
                if(result.status === 'success')
                    verifyCodeLength = 7;
            }, 
            error: function(){
                $("#blockUIProgress").css("display", "none");
                showMsgDialog("error", FMT("NASGeneralFail"));
            }
        });
    });    
    /*$(function(){
        $.ajax({
            // url: "Public/config/langConfig.json",
            // url: "Public/config/langSet",
            
            url: "/cmd/EonOne/config/langSetExisted",
            type:'GET',
            success: function (data) {              
                // config file existed, so we check the lang setting is set or not.   
                if(data=="false"){
                    // this means the lang have never been set, so we do detecting.
                    detectBrowserLang();
                }                     
            },
            error: function(){      
                // config file is not existed, it means the lang setting has not been set, so do detecting.
                detectBrowserLang();    
            }
        });
        
    });*/
    // function detectBrowserLang(){
    //     var lang = window.navigator.userLanguage || window.navigator.language ;     
    //     var check_lang=lang.toLowerCase();
    //     if(check_lang == "en"||check_lang == "en-au"||check_lang == "en-bz"||check_lang == "en-ca"||check_lang == "en-ie"||check_lang == "en-jm"||check_lang == "en-nz"||check_lang == "en-za"||check_lang == "en-tt"||check_lang == "en-gb"||check_lang == "en-us"){
    //         $('#currentLang').html("English");
    //         changeConfigLang('en');
    //     }else if(check_lang == "de"|| check_lang == "de-at" || check_lang == "de-li" || check_lang == "de-lu" || check_lang == "de-ch"){
    //         $('#currentLang').html("Deutsch");
    //         changeConfigLang('de');
    //     }else if(check_lang == "fr" || check_lang == "fr-be" || check_lang == "fr-ca" || check_lang == "fr-lu" || check_lang == "fr-ch"){
    //         $('#currentLang').html("Français");
    //         changeConfigLang('fr');
    //     }else if(check_lang == "ru" || check_lang == "ru-mo"){
    //         $('#currentLang').html("Русский");
    //         changeConfigLang('ru');
    //     }else if(check_lang == "ja"){
    //         $('#currentLang').html("日本語");
    //         changeConfigLang('jp');
    //     }else if(check_lang == "zh-cn"){
    //         $('#currentLang').html("简体中文");
    //         changeConfigLang('cn');
    //     }else if(check_lang == "zh-tw"){
    //         $('#currentLang').html("繁體中文");
    //         changeConfigLang('tw');
    //     }               
    //     else{
    //         $('#currentLang').html("English");
    //         changeConfigLang('en');
    //     }
    // }
    // function changeConfigLang(lang) {
    //     var host = location.host;
    //     getCurLangC(function(cLang) {
    //         if(cLang !== lang) {
    //             var date = new Date();
    //             var theUrl = '/cmd/EonOne/config/lang/' + lang + "?token="+date.getTime();
    //             $.ajax({
    //                 url: theUrl,
    //                 type: 'post',
    //                 dataType: 'html',
    //                 async: false,
    //                 success: function (data){
    //                     location.reload();
    //                 }
    //             }); 
    //         }
    //     });
    // } 
    /*// for original list
    function changeConfigLang2(lang) {
        var host = location.host;
        var date = new Date();
        var theUrl = '/cmd/EonOne/config/lang/' + lang + "?token="+date.getTime();
        $.ajax({
            url: theUrl,
            type: 'post',
            dataType: 'html',
            async: false,
            success: function (data){
                window.setTimeout('location.reload()', 1000);
            }
        });
    } */
});
(function() {
    var app = angular.module('gs-login', []);
    app.directive('passwordToggle', ['$timeout', function() {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            template: 
            '<div style="position:absolute;top:5px;left:282px;cursor:pointer;"><image ng-if="visibleType===&quot;password&quot;" src="Public/images/hide.png" ng-click="switchSecretVisible()"></image><image ng-if="visibleType===&quot;text&quot;" src="Public/images/show.png" ng-click="switchSecretVisible()"></image></div>',
            link: function(scope, element) {
                var eee = element.prev('input');
                if(eee.length) {
                    scope.visibleType = 'password';
                    eee.attr('type', 'password');
                    eee.css({
                        //'padding-right': '32px'
                    });
                    scope.switchSecretVisible = function() {
                        if(scope.visibleType === 'password') {
                            scope.visibleType = 'text';
                            eee.attr('type', 'text');
                        } else {
                            scope.visibleType = 'password';
                            eee.attr('type', 'password');
                        }
                    };
                }
            }
        };
    }]);
    app.directive('capsLock', ['$timeout', function() {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            template: '<div ng-if="isCapsLockOn" style="border:2px #FFF solid;border-radius: 3px; position:absolute;top:1px;height:33px;left:320px;"><image src="Public/images/icon_capslock_white.svg" style="margin-left:10px;margin-top:-3px;"></image><fmt key="CapsLock" style="font-size:14px;color:#FFF;margin-left:5px;margin-right:10px;margin-top:4px;display:inline-block;"></fmt></div>',
            link: function(scope, element) {
                var e = element.prevAll('input');
                var input = document.getElementById(e[0].id);
                scope.isCapsLockOn = false;
                input.addEventListener("keydown", function(event) {
                    if (event.getModifierState && event.getModifierState("CapsLock")) {
                        scope.isCapsLockOn = true;
                    } else {
                        scope.isCapsLockOn = false;
                    }
                    scope.$apply();
                });
                input.addEventListener("click", function(event) {
                    if (event.getModifierState && event.getModifierState("CapsLock")) {
                        scope.isCapsLockOn = true;
                    } else {
                        scope.isCapsLockOn = false;
                    }
                    scope.$apply();
                });
                input.addEventListener("focusout", function() {
                    scope.isCapsLockOn = false;
                    scope.$apply();
                });
            }
        };
    }]);
})();